import script from "./plan-discount-list.vue?vue&type=script&lang=jsx"
export * from "./plan-discount-list.vue?vue&type=script&lang=jsx"

import "./plan-discount-list.vue?vue&type=style&index=0&id=6eb0b844&lang=scss"

const __exports__ = script;

export default __exports__